import React from "react";
import { Typography } from "components";
import PropTypes from "prop-types";

import customHeaderImage from "../../../assets/images/custom-header-img.png";
import "./style.scss";

const CustomHeader = ({
  title,
  titlePosition,
  titleVariant,
  titleState,
  forModal,
  className
}) => (
  <div
    className={`${className} custom-header ${forModal ? "modal-custom-header" : ""} ${
      titlePosition === "center" ? "text-center" : ""
    }`}
  >
    <Typography variant={titleVariant} state={titleState}>
      {title}
    </Typography>
    <div className="d-none d-md-block">
      <img src={customHeaderImage} alt="" height="100%" />
    </div>
  </div>
);

CustomHeader.propTypes = {
  title: PropTypes.string.isRequired,
  titlePosition: PropTypes.string,
  forModal: PropTypes.bool,
  className: PropTypes.string,
};

CustomHeader.defaultProps = {
  titleVariant: "subtitle3",
  title: "Title",
  titleState: "primary",
};

export default CustomHeader;
